module.exports = __webpack_public_path__ + "img/childbirth.80925ca6.png";